import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ja from './locales/ja.json';
import en from './locales/en.json';
import zh from './locales/zh.json';
import fr from './locales/fr.json';
import es from './locales/es.json';
import ko from './locales/ko.json';

// サポートする言語。URLクエリ ?lng= で初期言語を指定できる（メールの言語リンクから遷移する用途）。
// 不正値・未指定のときは従来どおり 'ja' を既定にする。
const SUPPORTED = ['ja', 'en', 'zh', 'fr', 'es', 'ko'] as const;

function detectInitialLang(): string {
  try {
    const q = new URLSearchParams(window.location.search).get('lng');
    if (q && (SUPPORTED as readonly string[]).includes(q)) return q;
  } catch {
    /* window が無い環境では既定にフォールバック */
  }
  return 'ja';
}

i18n.use(initReactI18next).init({
  resources: {
    ja: { translation: ja },
    en: { translation: en },
    zh: { translation: zh },
    fr: { translation: fr },
    es: { translation: es },
    ko: { translation: ko },
  },
  lng: detectInitialLang(),
  fallbackLng: 'ja',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
